import { components } from "@certn/api/generated-schemas/client-portal";
import { Dialog, Modal } from "@certn/cascadia-react";

import { EditWebhookForm } from "./Form";

interface Props {
  isOpen: boolean;
  webhook: components["schemas"]["PublicAPIWebhookList"];
  onOpenChange(isOpen: boolean): void;
  onSuccess(): void;
}

export function EditWebhookModal({
  isOpen,
  onSuccess,
  webhook,
  onOpenChange,
}: Props) {
  return (
    <Modal
      testID="edit-webhook-modal"
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    >
      <Dialog>
        <EditWebhookForm
          webhook={webhook}
          close={() => onOpenChange(false)}
          onSuccess={onSuccess}
        />
      </Dialog>
    </Modal>
  );
}
